import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchActivityByIdRequest,
  clearActivityData,
} from "../store/activityFormSlice";
import {
  selectActivityData,
  selectIsFetchingActivity,
  selectFetchActivityError,
} from "../store/selectors";

export const useActivityHydration = (activityId) => {
  const dispatch = useDispatch();
  const activityData = useSelector(selectActivityData);
  const loading = useSelector(selectIsFetchingActivity);
  const error = useSelector(selectFetchActivityError);

  useEffect(() => {
    if (activityId) {
      dispatch(fetchActivityByIdRequest({ activityId }));
    }

    return () => {
      dispatch(clearActivityData());
    };
  }, [activityId, dispatch]);

  return {
    activityData,
    loading,
    error,
  };
};
